/**
 * PostHog tracking utility
 * 
 * Simple function to track PostHog events safely
 * @param {string} eventName - Name of the event to track
 * @param {object} properties - Event properties
 */
export const trackEvent = (eventName, properties = {}) => {
  if (window.posthog) {
    window.posthog.capture(eventName, properties);
  }
};